/* eslint-disable import/order */
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { proformaIssueFormsGeneralRoute } from '@jira/router-routes__proforma-routes/src/proformaIssueFormsGeneralRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ProformaIssueFormsGeneral, {
	LazyProformaIssueFormsGeneral,
} from './ui/issue-forms-general/index.tsx';

export const proformaIssueFormsGeneralRouteEntry: Route = createEntry(
	proformaIssueFormsGeneralRoute,
	() => ({
		group: 'proforma',
		layout: globalLayout,
		resources: [...getNavigationResources()],
		// eslint-disable-next-line no-restricted-syntax
		component: ProformaIssueFormsGeneral,
		forPaint: [LazyAtlassianNavigation, LazyProformaIssueFormsGeneral],
		perfMetricKey: 'issue-forms-general',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
